import { Entity, useGet } from '../../../../api';
import { USER_MANAGEMENT_BASE_URL } from '../consts';

export const useGetProtectedEntities = () => {
    const url = `${USER_MANAGEMENT_BASE_URL}/protectedEntities`;
    const { data: savedProtectedEntities, ...rest } = useGet<Entity[]>({ url });
    return {
        savedProtectedEntities,
        ...rest
    };
};
